import { render, staticRenderFns } from "./SabiaQueSection.vue?vue&type=template&id=1027b89a&scoped=true&"
import script from "./SabiaQueSection.vue?vue&type=script&lang=js&"
export * from "./SabiaQueSection.vue?vue&type=script&lang=js&"
import style0 from "./SabiaQueSection.vue?vue&type=style&index=0&id=1027b89a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1027b89a",
  null
  
)

export default component.exports